export default __webpack_public_path__ + "static/media/L1.96dfe170.webp";